/**
 * Phase 10C.5 — minimal i18n scaffold.
 *
 * No external dependency: a flat key→string dictionary per locale plus
 * a `t(key, locale)` resolver. The intent is that every non-trivial
 * page can call `useT()` and rely on a fallback chain
 *   `<requested locale>` → `en` → key string.
 *
 * Adding a new locale: drop a new file under `locales/<code>.ts`, add
 * the import in `MESSAGES`, ship a translated copy of the same keys.
 *
 * Locale parity is enforced by `tests/phase10/test_i18n_locales.py`
 * (asserts every English key is present in every other locale and
 * flags orphan translations missing from en.ts).
 */

import { en } from "./locales/en";
import { es } from "./locales/es";

export type Locale = "en" | "es";

const MESSAGES: Record<Locale, Record<string, string>> = { en, es };

export const SUPPORTED_LOCALES: Locale[] = ["en", "es"];


export function t(key: string, locale: Locale = "en"): string {
  return MESSAGES[locale]?.[key] ?? MESSAGES.en[key] ?? key;
}
